import React from "react";
import { Table } from "react-bootstrap";
import {
  fetchVideosAdmin,
  editVideo,
  deleteVideo,
  createVideo,
  getVideoCounter,
} from "../../actions/videoActions";
import { connect } from "react-redux";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import NavbarClass from "../NavbarClass";
import { Form as ReactFinalForm, Field } from "react-final-form";
import { isEmpty } from "lodash";
import { localAPI } from "../../api/local";
import { Redirect } from "react-router-dom";
import { sendDailyMailTest } from "../../actions/testAdminActions";
import history from "../../config/history";
import { Helmet } from "react-helmet";

class AdminVideoPage extends React.Component {
  async componentDidMount() {
    await this.props.fetchVideosAdmin(this.props.handleSignInOpen);

    await localAPI
      .get("/api/users/isadmin")
      .then((data) => {
        if (!data.data.success) this.setState({ isAdmin: false });
      })
      .catch((err) => {
        this.setState({ isAdmin: false });
      });

    await this.props.getVideoCounter();
  }

  state = {
    deleteModalShow: false,
    editAddModalShow: false,
    editModalShow: false,
    videoToDeleteEdit: {},
    isAdmin: true,
  };

  handleDeleteModalClose = () => {
    this.setState({ deleteModalShow: false, videoToDeleteEdit: {} });
  };
  handleDeleteModalShow = (video) =>
    this.setState({ deleteModalShow: true, videoToDeleteEdit: video });

  handleDeleteVideo = async (videoId) => {
    await this.props.deleteVideo(videoId, this.props.handleSignInOpen);
  };

  handleEditAddModalClose = () => {
    this.setState({ videoToDeleteEdit: {}, editAddModalShow: false });
  };

  handleEditAddModalShow = (videoRecieved) => {
    if (videoRecieved == {}) {
      this.setState({ editAddModalShow: true });
    } else
      this.setState({
        editAddModalShow: true,
        videoToDeleteEdit: videoRecieved,
      });
  };

  handleEditVideo = async (editedVideo) => {
    await this.props.editVideo(editedVideo, this.props.handleSignInOpen);
  };
  onEditModalSubmit = async (values) => {
    if (isEmpty(this.state.videoToDeleteEdit)) {
      await this.props.createVideo(values, this.props.handleSignInOpen);
    } else {
      await this.props.editVideo(values, this.props.handleSignInOpen);
    }
  };

  renderTable = () => {
    return this.props.videos.map((video, key) => {
      return (
        <tr
          key={key + 1}
          style={
            video.hideVideo ? { background: "rgba(128, 128, 128, 0.2)" } : {}
          }
        >
          <td>{key + 1}</td>
          <td>
            <img
              style={{ maxWidth: "100px" }}
              src={video.thumbnailLink}
              alt={`thumbnail for ${video.title}`}
              width="1200"
              height="700"
            />
          </td>
          <td>{video.title}</td>
          <td>{video.isFreeVideo ? "Yes" : "No"}</td>
          <td>som link</td>
          <td>{video.category}</td>
          <td>{video.playOrder}</td>
          <td>
            {new Date(video.uploadDateTime).toLocaleString("hi-IN", {
              dateStyle: "short",
              timeStyle: "short",
            })}
          </td>
          <td>
            <div
              className="btn btn-warning"
              onClick={() => this.handleEditAddModalShow(video)}
            >
              Edit
            </div>
            <div
              className="btn btn-danger"
              onClick={() => this.handleDeleteModalShow(video)}
            >
              Delete
            </div>
          </td>
        </tr>
      );
    });
  };
  //
  render() {
    return (
      <div>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        {this.props.videos ? (
          <div>
            <NavbarClass handleSignInOpen={this.props.handleSignInOpen} />
            <button
              className="btn btn-primary"
              onClick={() => this.handleEditAddModalShow({})}
            >
              {" "}
              Add Video{" "}
            </button>

            <button
              className="btn btn-secondary"
              onClick={() => this.props.sendDailyMailTest()}
            >
              SendDailyMail
            </button>

            <div>
              <p>Video Counter number : {this.props?.videoCounter}</p>
            </div>

            <Modal
              show={this.state.deleteModalShow}
              onHide={this.handleDeleteModalClose}
              animation={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Video</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.videoToDeleteEdit ? (
                  <Table>
                    <tr>
                      <h1>Delete This Video?</h1>
                    </tr>
                    <tbody>
                      <tr>
                        <th>Thumbnail</th>
                        <td>
                          <img
                            style={{ maxWidth: "100px" }}
                            src={this.state.videoToDeleteEdit.thumbnailLink}
                            alt={`thumbnail for ${this.state.videoToDeleteEdit.title}`}
                            width="1200"
                            height="700"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Title</th>
                        <td>{this.state.videoToDeleteEdit.title}</td>
                      </tr>
                      <tr>
                        <th>Free</th>
                        <td>
                          {this.state.videoToDeleteEdit.isFreeVideo
                            ? "Yes"
                            : "No"}
                        </td>
                      </tr>
                      <tr>
                        <th>Hidden</th>
                        <td>
                          {this.state.videoToDeleteEdit.hideVideo
                            ? "Yes"
                            : "No"}
                        </td>
                      </tr>
                      <tr>
                        <th>VideoLink</th>
                        <td>som link</td>
                      </tr>
                      <tr>
                        <th>Play Order</th>
                        <td>{this.state.videoToDeleteEdit.playOrder}</td>
                      </tr>
                      <tr>
                        <th>Upload Date</th>
                        <td>
                          {new Date(
                            this.state.videoToDeleteEdit.uploadDateTime
                          ).toLocaleString("hi-IN", {
                            dateStyle: "short",
                            timeStyle: "short",
                          })}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                ) : (
                  "No video found"
                )}{" "}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={this.handleDeleteModalClose}
                >
                  Close
                </Button>
                <Button
                  variant="warning"
                  onClick={
                    this.state?.videoToDeleteEdit &&
                    (() =>
                      this.handleDeleteVideo(this.state.videoToDeleteEdit._id))
                  }
                >
                  Delete
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              show={this.state.editAddModalShow}
              onHide={this.handleEditAddModalClose}
              animation={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Videos</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {
                  <div>
                    <ReactFinalForm
                      initialValues={
                        !(this.state.videoToDeleteEdit == {})
                          ? this.state.videoToDeleteEdit
                          : {}
                      }
                      onSubmit={this.onEditModalSubmit}
                      render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        values,
                      }) => {
                        return (
                          <form onSubmit={handleSubmit}>
                            {this.props.error && (
                              <Alert variant="danger">
                                <p>{this.props.error}</p>
                              </Alert>
                            )}
                            <Field name="title">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Enter title"
                                      name="title"
                                      autofocus
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="videoLink">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Video Link</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Video Link"
                                      name="videoLink"
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="thumbnailLink">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Thumbnail Link</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Thumbnail Link"
                                      name="thumbnailLink"
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="category">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Category</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Category"
                                      name="category"
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="storyId">
                              {({ input, meta }) => (
                                <div>
                                  <Form.Group className="mb-3">
                                    <Form.Label>Story ID</Form.Label>
                                    <Form.Control
                                      {...input}
                                      type="text"
                                      placeholder="Story Id"
                                      name="storyId"
                                    />
                                  </Form.Group>
                                </div>
                              )}
                            </Field>
                            <Field name="isFreeVideo" type="checkbox">
                              {({ input, meta }) => (
                                <div>
                                  <label for="isFreeVideo">Free Video</label>
                                  <input
                                    {...input}
                                    type="checkbox"
                                    id="isFreeVideo"
                                    name="isFreeVideo"
                                  />
                                </div>
                              )}
                            </Field>
                            <Field name="hideVideo" type="checkbox">
                              {({ input, meta }) => (
                                <div>
                                  <label for="hideVideo">Hide Video</label>
                                  <input
                                    {...input}
                                    type="checkbox"
                                    id="hideVideo"
                                    name="hideVideo"
                                  />
                                </div>
                              )}
                            </Field>
                            <Field name="playOrder" type="number">
                              {({ input, meta }) => (
                                <div>
                                  <label for="playOrder">Play Order</label>
                                  <input
                                    {...input}
                                    type="number"
                                    id="playOrder"
                                    name="playOrder"
                                  />
                                </div>
                              )}
                            </Field>

                            <button
                              className="btn btn-warning"
                              style={{ marginTop: "15px" }}
                              type="submit"
                            >
                              submit
                            </button>
                          </form>
                        );
                      }}
                    />
                  </div>
                }{" "}
              </Modal.Body>
            </Modal>

            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Thumbnail</th>
                  <th>Title</th>
                  <th>Free</th>
                  <th>VideoLink</th>
                  <th>Category</th>
                  <th>Play Order</th>
                  <th>Upload Date</th>
                  <th>Options</th>
                </tr>
                {this.props.videos ? this.renderTable() : "loading"}
              </thead>
            </Table>
          </div>
        ) : !this.state.isAdmin ? (
          <Redirect to="/" />
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    videos: state.videos.videos?.videos,
    loading: state.videos.loading,
    error: state.videos.error,
    videoCounter: state.videos?.videoCounter,
    // type: state.type,
  };
};

export default connect(mapStateToProps, {
  fetchVideosAdmin,
  editVideo,
  deleteVideo,
  createVideo,
  sendDailyMailTest,
  getVideoCounter,
})(AdminVideoPage);
